import { Container, Grid, Paper } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { Publicacion } from "../../Interface/IPublicacionOds";
import { I18nContext } from "../../I18nProvider";
import { useContext } from "react";

export interface PublicacionesOdsProps {
    publicaciones: Publicacion[];
    page: number;
    totalRows: number;
    setPage: (page: number) => void;
}



export const Publicaciones: React.FC<PublicacionesOdsProps> = ({

    publicaciones,
    page,
    totalRows,
    setPage,
}) => {
    const navigate = useNavigate();
    const context = useContext(I18nContext);

    if (context === null) {
        throw new Error(
            "The I18n context is not initialized. Make sure you have the provider set up correctly."
        );
    }

    const columns: GridColDef[] = [

        { field: "publicacion", headerName: context.t.translate("publicacion.publicacion"), flex: 0.5, resizable: false, sortable: false },
        { field: "anio", headerName: context.t.translate("publicacion.anio"), flex: 0.1, resizable: false, sortable: false },
        { field: "creator", headerName: context.t.translate("publicacion.primerAutor"), flex: 0.2, resizable: false, sortable: false },
        { field: "citedbyCount", headerName: "Conteo de Citas", flex: 0.2, resizable: false, sortable: false },

    ];

    const rows = publicaciones.map((publicacion) => ({

        /*id: publicacion.doi?.replace("/", "@"),*/
        id:publicacion.eid,
        publicacion: publicacion.title,
        anio:publicacion.year,
        creator: publicacion.creator,
        citedbyCount: publicacion.citedbyCount
    }));


    const handleRowClick = (params: any) => {
        const { id } = params.row;
        navigate(`/publicacion/${id}`);
    };




    return (
        <Container>

            <Grid container justifyContent="center" alignItems="center">
                <Grid item xs={12} sm={8} md={8}>
                    <Paper elevation={3} style={{ width: "100%", height: 400 }}>
                        <DataGrid
                            rows={rows}
                            columns={columns}
                            onRowClick={handleRowClick}
                            pageSizeOptions={[25]} 
                            paginationMode="server"
                            rowCount={totalRows}
                            paginationModel={{ page: page - 1, pageSize: 25 }}
                            onPaginationModelChange={(model) => setPage(model.page + 1)} 
                            disableColumnMenu
                            sx={{
                                "& .MuiDataGrid-columnHeaders": {
                                    backgroundColor: "blue !important",
                                    fontSize: "16px",
                                    fontWeight: "bold",
                                },
                                "& .MuiDataGrid-cell": {
                                    backgroundColor: "white",
                                    color: "black",
                                },
                                "& .MuiDataGrid-row:hover": {
                                    cursor: "pointer",
                                    backgroundColor: "#f5f5f5",
                                },
                                
                            }}
                        />

                    </Paper>
                </Grid>
            </Grid>
        </Container>
    );
};
